import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie'; // Cookie işlemleri için import

const api = "https://apideneme.com.tr/api"; // API adresini belirtin

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${api}/login`, { email, password });
      const { id, token } = response.data;

      // Kullanıcı ID'sini localStorage'a kaydediyoruz
      localStorage.setItem('user_id', id);

      // Kullanıcı ID'sini ve token'ı cookie olarak kaydediyoruz
      Cookies.set('user_token', token, { expires: 7 }); // token 7 gün boyunca geçerli
      Cookies.set('user_id', id, { expires: 7 }); // user_id de cookie olarak saklanacak

      // Eğer kullanıcı adminse (id 1 ise) items sayfasına yönlendir
      if (id === 1) {
        navigate('/items');
      } else {
        navigate('/user-items'); // Diğer kullanıcılar için özel sayfa
      }
    } catch (error) {
      console.error("Giriş sırasında hata oluştu:", error);
      setError(error.response?.data?.message || 'Giriş başarısız. Lütfen bilgilerinizi kontrol edin.');
    }
  };

  const handleRegister = () => {
    navigate('/register'); // Kayıt sayfasına yönlendirin
  };
  return (
    <div className="login-container">
      <h2>Login</h2>
      {error && <p className="error-message">{error}</p>}
      <form onSubmit={handleLogin} className="login-form">
        <div className="input-group">
          <span className="icon" role="img" aria-label="user icon">&#128100;</span>
          <input
            type="text"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="input-group">
          <span className="icon" role="img" aria-label="lock icon">&#128274;</span>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          <button 
            type="submit" 
            style={{ flex: '0 0 70%', padding: '10px', backgroundColor: '#333', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
          >
            Log In
          </button>
          <button 
            type="button" 
            onClick={handleRegister} 
            style={{ flex: '0 0 30%', padding: '10px', backgroundColor: 'gray', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}
          >
            Register
          </button>
        </div>
      </form>
    </div>
  );
};

export default Login;
